<template>
    <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.53318 10.0001H9.53318L9.49999 -0.00158691L8.5 0.00173122L8.53318 10.0001ZM14.4502 14.5001V15.5001H23.2929L20.1464 18.6465L20.8536 19.3536L24.8536 15.3536L25.2071 15.0001L24.8536 14.6465L20.8536 10.6465L20.1464 11.3536L23.2929 14.5001H14.4502Z" fill="#333333"/>
        <g filter="url(#filter0_d_327_2748)">
            <rect width="12" height="12" transform="translate(3 9)" fill="white"/>
            <path d="M8.25 15L6 17.25L6.75 18L9 15.75L11.25 18L12 17.25L9.75 15L12 12.75L11.25 12L9 14.25L6.75 12L6 12.75L8.25 15Z" fill="#00458D"/>
        </g>
        <defs>
            <filter id="filter0_d_327_2748" x="0" y="6" width="20" height="20" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                <feOffset dx="1" dy="1"/>
                <feGaussianBlur stdDeviation="2"/>
                <feComposite in2="hardAlpha" operator="out"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_327_2748"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_327_2748" result="shape"/>
            </filter>
        </defs>
    </svg>
</template>

<script>
export default {
    name: 'SVGShelfSeparatorDropdown',
};
</script>

<style scoped lang="scss">

</style>
